<template>
  <el-drawer
    :visible.sync="visible"
    :title="title"
    :append-to-body="true"
    size="85%"
    class="merchant-help-drawer-container"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onClose"
  >
    <merchant-help ref="merchantHelp" @onCancel="onCancel" @onSuccess="onSuccess" />
  </el-drawer>
</template>
<script>
import MerchantHelp from './merchant-help'
export default {
  name: 'merchantHelpDrawer',
  components: { MerchantHelp },
  props: {
    title: String,
    modelValue: Boolean
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  watch: {
    modelValue: {
      handler(newV, oldV) {
        if (newV) {
          try {
          } catch (error) {}
        }
      }
    }
  },
  computed: {
    visible: {
      get() {
        return this.modelValue
      },
      set(val) {
        this.$emit('update:modelValue', val)
      }
    }
  },
  data() {
    return {}
  },
  created() {},
  methods: {
    async onSuccess() {
      this.visible = false
      this.$emit('onSuccess')
    },
    async onCancel() {
      this.visible = false
      this.$emit('onCancel')
    },
    async onClose() {
      this.$emit('onClose')
    }
  }
}
</script>
<style lang="scss" scoped>
.merchant-help-drawer {
  &-container {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/help/components/merchant-help-drawer.vue